import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '../components/Layout.vue';
import Home from '../pages/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home
      },
      {
        path: '/about',
        name: 'About',
        component: () => import('@/pages/About.vue')
      },
      {
        path: '/blog',
        name: 'Blog',
        component: () => import('@/pages/Blog.vue')
      },
      {
        path: '/blog/:id',
        name: 'BlogDetail',
        component: () => import('@/pages/BlogDetail.vue')
      },
      {
        path: '/products',
        name: 'Products',
        component: () => import(/* webpackChunkName: "products" */ '@/pages/Products.vue')
      },
      {
        path: '/product/:id',
        name: 'ProductDetail',
        component: () => import(/* webpackChunkName: "product-detail" */ '@/pages/ProductDetail.vue')
      },
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
